import React, { useState, useEffect, useCallback } from 'react';
import { 
  Wifi, 
  FileText, 
  RefreshCw, 
  AlertCircle,
  DollarSign
} from 'lucide-react';
import { LoadingSpinner } from 'components/common';
import api from '../../../../services/api';

const XtFibraDashboard = ({ action, refreshKey = 0 }) => {
  const [dashboardData, setDashboardData] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  const fetchDashboardData = useCallback(async () => {
    try {
      setLoading(true);
      setError(null);
      const response = await api.get('/automacoes/dashboard', {
        params: { action }
      });
      const payload = response?.data?.data ?? response.data;
      setDashboardData(payload);
    } catch (err) {
      console.error('Erro ao carregar dashboard XT Fibra:', err);
      setError(err.response?.data?.message || err.message || 'Erro ao carregar dados');
    } finally {
      setLoading(false);
    }
  }, [action]);

  useEffect(() => {
    fetchDashboardData();
  }, [fetchDashboardData, refreshKey]);

  if (loading) {
    return (
      <LoadingSpinner
        fullScreen={false}
        className="min-h-[240px] w-full"
        cardClassName="max-w-md w-full"
        label="Carregando dashboard XT Fibra"
        subtitle="Aguarde enquanto atualizamos os dados."
      />
    );
  }

  if (error) {
    return (
      <div className="text-center py-8">
        <AlertCircle className="h-12 w-12 text-red-500 mx-auto mb-4" />
        <h3 className="text-lg font-medium text-[color:var(--text-primary)] mb-2">Erro ao carregar dados</h3>
        <p className="text-[color:var(--text-muted)] mb-4">{error}</p>
        <button 
          onClick={fetchDashboardData}
          className="inline-flex items-center px-4 py-2 bg-[color:var(--accent)] text-white rounded-md hover:opacity-90"
        >
          <RefreshCw className="h-4 w-4 mr-2" />
          Tentar novamente
        </button>
      </div>
    );
  }

  return (
    <div className="space-y-6">
      {/* Cabeçalho específico */}
      <div className="bg-[color:var(--surface)] rounded-lg shadow-sm border border-[color:var(--border)] p-6">
        <div className="flex items-center justify-between">
          <div className="flex items-center space-x-3">
            <div className="p-2 bg-[color:var(--surface-muted)] rounded-lg">
              <Wifi className="h-6 w-6 text-purple-600" />
            </div>
            <div>
              <h1 className="text-2xl font-bold text-[color:var(--text-primary)]">XT Fibra</h1>
              <p className="text-[color:var(--text-muted)]">Dashboard de automações da XT Fibra</p>
            </div>
          </div>
        </div>
      </div>

      {/* Cards de métricas específicas da XT Fibra */}
      <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
        {/* Financeiro Gerado */}
        <div className="bg-[color:var(--surface)] p-6 rounded-lg border border-[color:var(--border)]">
          <div className="flex items-center">
            <div className="p-2 bg-[color:var(--surface-muted)] rounded-lg">
              <FileText className="h-6 w-6 text-blue-600" />
            </div>
            <div className="ml-4">
              <p className="text-sm font-medium text-[color:var(--text-muted)]">Financeiro Gerado</p>
              <p className="text-2xl font-bold text-[color:var(--text-primary)]">
                {dashboardData?.[0]?.xt_gera_financeiro_finaliza_mensal || 0}
              </p>
            </div>
          </div>
        </div>

        {/* Multa de Comodato Geradas */}
        <div className="bg-[color:var(--surface)] p-6 rounded-lg border border-[color:var(--border)]">
          <div className="flex items-center">
            <div className="p-2 bg-[color:var(--surface-muted)] rounded-lg">
              <DollarSign className="h-6 w-6 text-red-600" />
            </div>
            <div className="ml-4">
              <p className="text-sm font-medium text-[color:var(--text-muted)]">Multa de Comodato Geradas</p>
              <p className="text-2xl font-bold text-[color:var(--text-primary)]">
                {dashboardData?.[0]?.xt_multa_equipamentos_mensal || 0}
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default XtFibraDashboard;
